import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FusePipesModule } from './pipes/pipes.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FuseDirectivesModule } from './directives/directives';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { 
    FuseSearchBarModule, 
    FuseShortcutsModule, 
    FuseNavigationModule, 
    FuseSidebarModule, 
    FuseThemeOptionsModule,
    FuseWidgetModule
} from '@fuse/components';

@NgModule({
    imports  : [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        FlexLayoutModule,
        FuseDirectivesModule,
        FusePipesModule,
        FuseSearchBarModule,
        FuseShortcutsModule,
        FuseNavigationModule,
        FuseSidebarModule, 
        FuseThemeOptionsModule,
        FuseWidgetModule
    ],
    exports  : [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        FlexLayoutModule,
        FuseDirectivesModule,
        FusePipesModule,
        FuseSearchBarModule,
        FuseShortcutsModule,
        FuseNavigationModule,
        FuseSidebarModule, 
        FuseThemeOptionsModule,
        FuseWidgetModule
    ]
})
export class FuseSharedModule
{
}
